<script>
import {getAction} from "@/utils/http/service";
import {common_controller} from "@/api/commonService";

export default {
    name: "DictCheckbox",
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        dictName: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            internalValue: this.value,
            options: []
        }
    },
    mounted() {
        getAction({
            url: common_controller.getDictDataByGroupNumber,
            params: {
                groupNumbers: this.dictName
            }
        }).then(res => {
            this.options = res;
        })
    },
    watch: {
        value(newVal) {
            this.internalValue = newVal;
        },
    },
    methods: {
        handleChange(checkedValues) {
            this.internalValue = checkedValues;
            this.$emit('input', checkedValues); // 支持 v-model
            this.$emit('change', checkedValues); // 支持 change 事件
        },
    },
}
</script>

<template>
    <a-checkbox-group :value="internalValue"
                      v-bind="$attrs"
                      @change="handleChange">
        <a-checkbox v-for="(item,index) in options"
                    :key="index" :value="item.dictValue">
            {{ item.dictLabel }}
        </a-checkbox>
    </a-checkbox-group>
</template>

<style scoped lang="less">

</style>
